import { render, staticRenderFns } from "./RiepilogoPrenotazione.vue?vue&type=template&id=5d44391c&scoped=true&"
import script from "./RiepilogoPrenotazione.vue?vue&type=script&lang=js&"
export * from "./RiepilogoPrenotazione.vue?vue&type=script&lang=js&"
import style0 from "./RiepilogoPrenotazione.vue?vue&type=style&index=0&id=5d44391c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d44391c",
  null
  
)

export default component.exports